// extracted by mini-css-extract-plugin
module.exports = {"pressNews":"PressNews_pressNews__jfwfF","content":"PressNews_content__uwMbv","newsList":"PressNews_newsList__tmN6v"};